import { useEffect, useState } from 'react';

/** Bố cục khung theo thiết bị (Hybrid-Kit §8, board Mint-Home / -iPad / -Phone):
 *  - side: desktop ≥ 1440 — sidebar 248 (thu được về rail 64)
 *  - rail: desktop < 1440 (vd 1280) — rail 64, nhóm mở menu nổi, ☰ mở sidebar nổi
 *  - pad: iPad / màn chạm 768–1366 — không rail, nút ☰ trên đầu trang mở menu nổi 300
 *  - phone: < 768 — thanh trên + thanh tab dưới + bảng "Thêm" */
export type Layout = 'side' | 'rail' | 'pad' | 'phone';

export function layoutFor(width: number, coarse: boolean): Layout {
  if (width < 768) return 'phone';
  if (coarse && width <= 1366) return 'pad';
  return width >= 1440 ? 'side' : 'rail';
}

export function useLayout(): Layout {
  const read = () => (typeof window === 'undefined' ? 'side' : layoutFor(window.innerWidth, matchMedia('(pointer: coarse)').matches));
  const [l, setL] = useState<Layout>(read);
  useEffect(() => {
    const on = () => setL(read());
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return l;
}
